import type { DocumentCapabilities } from '../types/documents';

export type DocumentManagerPermissions = Pick<
  DocumentCapabilities,
  'create' | 'upload' | 'rename' | 'delete' | 'download' | 'move' | 'copy'
>;

const CAPABILITY_KEYS: ReadonlyArray<keyof DocumentCapabilities> = [
  'create',
  'upload',
  'rename',
  'delete',
  'download',
  'move',
  'copy',
  'search',
  'zip',
  'restore',
];

/**
 * Normalizza il contratto restituito dal backend con un default fail-closed.
 * Solo il booleano `true` abilita un'azione; campi assenti o valori non booleani
 * restano disabilitati. La validazione definitiva rimane sempre sul backend.
 */
export const normalizeDocumentCapabilities = (value: unknown): DocumentCapabilities => {
  const source = value && typeof value === 'object'
    ? value as Record<string, unknown>
    : {};

  return CAPABILITY_KEYS.reduce<DocumentCapabilities>((capabilities, key) => {
    capabilities[key] = source[key] === true;
    return capabilities;
  }, {} as DocumentCapabilities);
};

/** Traduce le capability pubbliche nei soli permessi compresi da Cubone. */
export const toDocumentManagerPermissions = (
  capabilities: DocumentCapabilities,
): DocumentManagerPermissions => ({
  create: capabilities.create,
  upload: capabilities.upload,
  rename: capabilities.rename,
  delete: capabilities.delete,
  download: capabilities.download,
  move: capabilities.move,
  copy: capabilities.copy,
});
